/**
 * Document view component.
 * @module components/theme/View/ListingView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Container as SemanticContainer } from 'semantic-ui-react';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

/**
 * List view component class.
 * @function ListingView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const ListingView = ({ content }) => {
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  const PreviewImage = config.getComponent({ name: 'PreviewImage' }).component;

  const getViewURL = function (item) {
    let URL = flattenToAppURL(item['@id'])
    if (item['@type'] === 'File') {
      URL += '/@@display-file/file'
    }
    if (item['@type'] === 'Image') {
      URL += '/@@display-file/image'
    }
    if (item?.getRemoteUrl) {
      URL = item?.getRemoteUrl
    }
    return URL
  }

  return (
    <Container id="page-home">
      <section id="content-core">
        {content.items.map((item) => (
          <Segment key={item.url} className="listing-item">
            <Container>
              <h2>
                <UniversalLink href={getViewURL(item)} title={item['@type']}>
                  {item.title}
                </UniversalLink>
              </h2>
              {item.description && <p>{item.description}</p>}
            </Container>
            {item.image_field && (
              <PreviewImage
                item={item}
                alt={item.image_caption ? item.image_caption : item.title}
                className="ui image"
                responsive={true}
                loading="lazy"
              />
            )}
          </Segment>
        ))}
      </section>
    </Container>
  );
};


export default ListingView;
